<template>
  <div v-show="loading">
    <div class="fullview">
      <div class="loading-spacer"></div>
      <v-card flat>
         <v-card-text class="text-center">
            <vue-loading 
              type="spiningDubbles"
              color="#aaa"
              :size="{ width: '100px', height: '100px' }"
              >
            </vue-loading>
<!--
           <div><v-icon class="my-5" color="teal darken-1" x-large>mdi-checkbox-marked-circle</v-icon></div>
-->
           <p class="mt-10" v-html="message"></p>

          <div v-for="progress of progressMessages" v-bind:key="progress.message">
              <v-icon v-if="progress.status==0" small class="my-1 mr-1" color="gray darken-1">mdi-checkbox-marked-circle</v-icon>
              <v-icon v-else small class="my-1 mr-1" color="teal darken-1">mdi-checkbox-marked-circle</v-icon>
              {{ progress.message }}
          </div>

        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { VueLoading } from 'vue-loading-template'

export default {
  name: 'loading',
  components: {
    VueLoading,
  },
  props:["message", "progressMessages"],
  data(){
    return{
      loading: false
    }
  },
  methods: {
    start() {
      this.loading = true;
    },
    end() {
      this.loading = false;
    }
  }
}
</script>

<style>
.fullview {
  width: 100%;
  height: 100%;
  background: #fefefe;
  position: fixed;
  top: 0;
  left: 0;
}
.loading-spacer {
  height: 30%;
}
</style>